import { NgModule } from '@angular/core';
import { ProductResource } from '@df/catalog/product/product.resource';
import { Basket } from '@df/session/api/basket/basket';
import { BasketItemFactory } from '@df/session/api/basket/basket-item.factory';
import { CatalogCommonModule } from '../../catalog/catalog-common.module';
import { SharedModule } from '../../shared.module';
import { GiftcardsBasketDetailsComponent } from './basket/details/giftcards-basket-details.component';
import { GiftcardsBasketItem } from './basket/giftcards-basket-item';
import { Nexus } from '@tomandco/nexus-api-types';

@NgModule({
    imports: [
        // CatalogCommonModule,
        SharedModule,
        CatalogCommonModule
    ],
    declarations: [GiftcardsBasketDetailsComponent],
    exports: [GiftcardsBasketDetailsComponent]
})
export class GiftcardsBasketModule {
    constructor(productResource: ProductResource) {
        BasketItemFactory.beforeCreatePlugins.push((data: Nexus.Lib.Basket.BasketItem, basket: Basket) => {
            if (productResource.getExisting(data.product)?.giftCard?.isGiftcard) {
                return new GiftcardsBasketItem(data, basket);
            }
            return undefined;
        });
    }
}
